import { defaultTheme } from 'react-select';

/**
 * ТЗ 0119 — react-select (v4) в теме ERP.
 *
 * Его цвета — inline-стили emotion из общего объекта `defaultTheme`; темой
 * через CSS их не перекрыть (классы хешированы). Поэтому цвета этого
 * объекта один раз при старте подменяются на переменные палитры: светлое
 * значение каждой — прежний цвет react-select (hsl → тот же hex), тёмное —
 * по роли (фон, рамка, текст). Все AsyncSelect/Select ERP, и с собственным
 * `styles`, берут цвета отсюда.
 */
const COLORS: Record<string, string> = {
  // рамка фокуса и фон выбранного пункта; текст на нём — neutral0 (фон
  // поля), поэтому в тёмной теме это светлая бирюза: тёмный текст на ней ~6:1
  primary: 'var(--k-border-2684ff)',
  primary75: 'var(--k-bg-4c9aff)',
  primary50: 'var(--k-bg-b2d4ff)', // нажатый пункт
  primary25: 'var(--k-bg-deebff)', // пункт под курсором
  danger: 'var(--k-fg-de350b)',
  dangerLight: 'var(--k-bg-ffbdad)',
  neutral0: 'var(--k-bg-ffffff)', // фон поля и меню
  neutral5: 'var(--k-bg-f2f2f2)', // фон выключенного поля
  neutral10: 'var(--k-bg-e6e6e6)', // чип мультивыбора
  neutral20: 'var(--k-border-cccccc)', // рамка, значки
  neutral30: 'var(--k-border-b3b3b3)', // рамка при наведении
  neutral40: 'var(--k-fg-999999)', // «нет вариантов», значок при наведении
  neutral50: 'var(--k-fg-808080)', // плейсхолдер
  neutral60: 'var(--k-fg-666666)', // значок в фокусе
  neutral70: 'var(--k-fg-4d4d4d)',
  neutral80: 'var(--k-fg-333333)', // выбранное значение
  neutral90: 'var(--k-fg-1a1a1a)',
};

let installed = false;

export const installReactSelectTheme = (): void => {
  if (installed) return;
  installed = true;
  Object.assign(defaultTheme.colors, COLORS);
};
